<template>
	<div class="wrapper">
		<section class="side">
			<p class="main-msg">{{ $t('sloganMain1') }} </p>
			<p class="main-msg">{{ $t('sloganMain2') }} </p>
			<p class="secondary-msg">{{ $t('productVision1') }}</p>
			<!-- <router-link :to="'/' + $i18n.locale"><img src="../assets/static/icons/expar_logo_new2.svg" alt="expar logo"></router-link> -->
		</section>

		<section class="main">
			<div class="backBtn">
				<a v-if="env === 'production'" href="https://expar.si/" class="previous">&#8249; {{ $t('back') }}</a>
				<a v-else href="https://demo.expar.si/" class="previous">&#8249; {{ $t('back') }}</a>
			</div>
			<div class="languageSwitcher">
				<language-switcher />
			</div>
			<div class="signInLogo">
			<img src="../assets/static/icons/expar_logo_new2.svg" alt="expar_logo" />
			</div>
		<br/>
			<!-- <div class="divider">
				<hr class="left"/>or<hr class="right" />
			</div> -->
			<br/>
			<!-- <router-link class="close" :to="'/' + $i18n.locale"></router-link> -->
			<form @submit.prevent="login">
				<div class="form-control">
					<input 
					v-model="email" 
					data-testid="email-input"
					data-qa="emailInput"
					type="email" 
					name="email" 
					:placeholder="$t('email')"
					value v-on="$listeners" 
					@blur="$v.email.$touch()" 
					v-on:input="resetErrorMessage"
					:class="{ 'error-boarder': $v.email.$error }" >
					<i class="fas fa-envelope"></i>
				</div>
				<!--error message -->
				<template v-if="$v.email.$error">
					<div v-if="!$v.email.email" class="errorMessage">{{ $t('emailValid') }}</div>
					<div v-if="!$v.email.required" class="errorMessage">{{ $t('emailReq') }}</div>
				</template>
				<!--END of error message -->
				<div class="form-control">
					<input 
					v-model="password" 
					:class="{ 'error-boarder': $v.password.$error }" 
					:type="passwordFieldType" 
					name="password" 
					data-qa="passwordInput"
					:placeholder="$t('password')"
					@blur="$v.password.$touch()"
					v-on="$listeners" 
					v-on:input="resetErrorMessage"
					value >
					<i class="fas fa-lock"></i>
					<button class="eyeIcon" type="button" @click="switchVisibility">
					<span class="input-group-text" @click="showPassword = !showPassword">
						<i class="fa" :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']" aria-hidden="true"></i>
					</span>
					</button>
				</div>
				<!--error message -->
				<template v-if="$v.password.$error">
					<div v-if="!$v.password.required" class="errorMessage">{{ $t('passReq') }}</div>
				</template>
				<!--END of error message -->

				<div v-if="this.error" class="errorMessage">
					{{ this.error }}
				</div>

				<button :disabled="$v.$invalid" class="action" data-qa="loginButton" type="submit" name="button">{{ $t('login') }}</button>

				<br/>
				<div class="options-01">
					<!-- <label class="remember-me"
					><input type="checkbox" name="" />Remember me</label
					> -->
					<a class="forgotPass" data-qa="forgotPasswordLink" @click="$bvModal.show('forgot-password')">{{ $t('forgotPass') }}</a>
				</div>
			</form>

			<div class="login">
				<p> {{ $t('notHaveAccount') }}</p>
				<router-link :to="'/' + 'register/' + $i18n.locale"><button>{{ $t('signup') }}</button></router-link>
			</div>
		</section>
		<b-modal id="forgot-password" hide-footer>
			<template v-slot:modal-title>
			{{ $t('sendPass') }}
			</template>
			<forgotPassword 
			@success-mail="hideForgotPasswordModel"
			/>
		</b-modal>
		<sweet-modal icon="success" ref="modalSuccess" name="successModal">
				{{ $t('mailSentSuccess') }}
		</sweet-modal>
		<!--2FA signin modal-->
			<!-- <sweet-modal icon="success" ref="modalSuccess" name="successModal2FA">
				{{ $t('accountCreated') }}
				<br />
				<br />
				<p>{{ $t('scanWithAuthenticationApp') }}</p>
				<div>QR CODE HERE (from Speakeasy)</div>
				<br />
				<p>{{ $t('verifyWithAuthenticationApp') }}</p>
				<form @submit.prevent="verifyAccount">
					<div class="form-control">
						<input
							class="user-input"
							v-model="verificationCode"
							:class="{ 'error-boarder': $v.verificationCode.$error }"
							data-qa="verificationCodeInput"
							name="password"
							:placeholder="$t('verificationCode')"
							@blur="$v.verificationCode.$touch()"
							v-on="$listeners"
							v-on:input="errors = null"
							value
						/>
						<i class="fas fa-lock"></i>
					</div>
				</form>
				<template v-if="$v.verificationCode.$error">
					<div v-if="!$v.verificationCode.required" class="errorMessage">
						{{ $t('verificationCodeReq') }}
					</div>
				</template>
				<br/>
				<button
				@click="login"
				class="info-btn"
				:disabled="$v.$invalid" 
				data-qa="signInButton"
				>
				{{ $t('confirmSignIn') }}
				</button>
				<br/>
				<p>{{ $t('2FADisclaimerToDisable') }}</p>
			</sweet-modal> -->
		<!--END OF 2FA signin-->
	</div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import forgotPassword from '../components/common/forgotPassword'
import { SweetModal } from 'sweet-modal-vue'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'


export default {
metaInfo() {
    return {
      title: this.$i18n.t('login'),
    }
},
  components: {
    forgotPassword,
    SweetModal,
	LanguageSwitcher
  },
  data() {
    return {
      env: '',
      email: '',
      password: '',
      error: null,
      type: "login",
      passwordFieldType: 'password',
      showPassword: false
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  mounted() {
    this.env = process.env.NODE_ENV
  },
  methods: {
    login() {
      this.$store
        .dispatch('login', {
          email: this.email,
          password: this.password,
        })
        .then(() => {
          const user = JSON.parse(localStorage.getItem('user'))
          const { role, id } = user
          if (this.isChckoutLogin) {
          	this.$emit('login-response', user)
          } else {
            if (role === 'admin') {
              this.$router.push({ name: 'adminPanel' }) // automatically redirect to dashboard when user click "register"//
            } else if (role === 'user') {
              this.$router.push({ name: 'user', params: { userId: id } }) // automatically redirect to dashboard when user click "register"//
            } else if (role === 'cleaner') {
              this.$router.push({ name: 'unit-list-cleaner' }) // automatically redirect to dashboard when user click "register"//
            } else if (role === 'support') {
              this.$router.push({ name: 'supportPanel' }) // automatically redirect to dashboard when user click "register"//
            } else {
              this.$router.push({ name: 'dashboard' }) // automatically redirect to dashboard when user click "register"//
            }
          }
        })
        .catch((err) => {
          // console.log('Show error notification!')
          this.error = err.data.message
        })
      this.$v.$touch()
      if (!this.$v.$invalid) {
        // console.log("form submitted:", this.email);
      }
    },
    redirectRegister() {
      if(this.isChckoutLogin) {
        this.$emit('register-redirect', true)
      } else {
        this.$router.push({ name: 'register' }) 
      }
    },
    resetErrorMessage() {
      if (this.error) this.error = null
    },
    resetModalErrors() {
      this.email=''
      this.password=''
      this.$v.$reset()
    },
    async loginResponse() {
      const user = JSON.parse(localStorage.getItem('user'))
      this.$emit('login-response', user)
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    hideForgotPasswordModel() {
      this.$refs.modalSuccess.open()
      this.$bvModal.hide('forgot-password')
    }
  },
  props: {
    isChckoutLogin: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}
.logo-img path {
  fill: var(--primary);
}
.wrapper {
    // min-height: 100vh;
    display: grid;
    grid-template-columns: 60% 1fr;
    color: #696969;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}

.secondary-msg {
  font-size: 1.2em;
  color: var(--bright);
  padding: 25px;
}

.eyeIcon {
  position: absolute;
    top: 20px;
    right: 20px;
}

.signInLogo {
  width: 40%;
  margin-bottom: 2em;
}
.cls-1 {
  fill: var(--primary);
}
.shadow {
  -webkit-filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  /* Similar syntax to box-shadow */
  }
section {
    display        : flex;
    flex-direction : column;
    justify-content: center;
    align-items    : center;
    padding        : 48px;
}
// .error {
//   background-color: none !important;
//   border-color: red !important;
// }
.error-boarder {
  border: 2px solid var(--primaryDark);
}
.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  display: inline;
  margin-top: -1.2em;
}
.forgotPass {
  color: var(--bg) !important;
  background-color: none !important;
  text-decoration-line: none;
  cursor: pointer;
}
.forgotPass:hover {
  text-decoration-line: underline;
}

.forgotPass:active {
  color: var(--primary) !important;
  text-decoration-line: none;
}
.languageSwitcher {
	position: absolute;
    // background-color: var(--bg);
    top: 20px;
    right: 20px;
}

.close {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}


.side {
  background: linear-gradient(193deg, rgba(12,46,68,1) 0%, rgba(61,88,105,1) 28%, rgba(96,93,108,1) 64%, rgba(251,115,119,1) 100%);
	height: 100%;
}

.side img {
    width    : 30%;
}

.side p {
    max-width     : 500px;
    color         : #ddfdff;
    letter-spacing: 1px;
    line-height   : 1.8em;
    margin-bottom : 40px;
}

.side .main-msg {
  color        : var(--bgDark);
  font-size: 3.2em;
  font-weight: 900;
  line-height: 1.2em;
  margin-bottom: 10px;
}

.title {
    font-size     : 3em !important;
    font-weight   : bold;
    text-align    : center;
    letter-spacing: 1px;
    color: var(--bg);
}

.divider {
  color: var(--bg);
	width: 100%;
	text-align:center;
}

.divider hr {
	margin-left:auto;
	margin-right:auto;
	width:40%;

}

.left {
	float:left;
}

.right {
	float:right;
}

.welcome-message {
    text-align   : center;
    font-size    : 1.1em;
    line-height  : 28px;
    margin-bottom: 10px;
}

form {
    width         : 100%;
    max-width: 400px;
    display       : flex;
    flex-direction: column;
}

.form-control {
    width        : 100%;
    position     : relative;
    margin-bottom: 40px;
    border: none !important;
}

input,
button {
    border       : none;
    outline      : none;
    border-radius: 30px;
    font-size    : 1.1em;
}

input {
    width         : 100%;
    background    : #e6e6e6;
    color         : #333;
    letter-spacing: 0.5px;
    padding       : 14px 64px;
}

input~i {
    position  : absolute;
    left      : 22px;
    top       : 80%;
    transform : translateY(-50%);
    color     : var(--gray);
    transition: color 0.4s;
    font-size: 1.3em;
}

input:focus~i {
    color: #0E484B;
}

button.action {
    color           : #fff;
    padding         : 14px 64px;
    margin          : 32px auto;
    text-transform  : uppercase;
    letter-spacing  : 2px;
    font-weight     : bold;
    background-color: var(--primary);
    background: var(--primary);
    cursor          : pointer;
    transition      : opacity 0.4s;
}

button.action:hover {
    opacity: 0.9;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.login {
    position       : absolute;
    bottom         : 20px;
    display        : flex;
    justify-content: center;
    align-items    : center;
}

.login button {
    margin-left  : 16px;
    background   : none;
    color: var(--bg);
    border-bottom: 2px solid var(--bg);
    border-radius: 0;
    padding      : 4px;
    cursor       : pointer;
    font-weight  : bold;
}

.login button:hover {
    color: var(--primary);
    border-bottom: 2px solid var(--primary);
}


.login p {
  margin-bottom: 0;
}

/* Arrow Styling */
.backBtn {
	position: absolute;
    top: 20px;
    left: 30px;
}
.backBtn a {
  text-decoration: none;
  display: inline-block;
  padding: 8px 16px;
}
.backBtn a:hover {
  background-color: var(--primaryLight);
  color: black;
}
.backBtn .previous {
  background-color: var(--bg);
  color: var(--bright);
}
/* END OF Arrow Styling */

/* ----  Responsiveness   ----  */

@media (max-width: 480px) {
section {
  padding: 8px 15px 60px 15px;
}
.login {
  bottom: 15px;
}
.wrapper {
  height: 100vh;
}
.backBtn {
    top: 10px;
    left: 10px;
}
.backBtn a:hover {
  background-color: none;
  color: var(--primary);
}
.backBtn .previous {
  background-color: var(--bright);
  color: var(--bg);
}
}

@media (max-width: 780px) {
    .wrapper {
        grid-template-columns: 1fr;
    }
	.login {
		bottom: 20px;
	}
    .side {
        display: none;
    }
    .section {
      padding-bottom: 0;
    padding-top: 0;
    }
}

@media (min-width: 775px) {
.close {
  display: none;
}
}

</style>